const PremiumType = {
  PREMIUM: 'PREMIUM',
  SUPPORT: 'SUPPORT',
}

export default PremiumType
